import { render, staticRenderFns } from "./MSelectUploadimg.vue?vue&type=template&id=436dcc92&"
import script from "./MSelectUploadimg.vue?vue&type=script&lang=ts&"
export * from "./MSelectUploadimg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports